import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  UpdateAddressPayload,
  UpdateUserPayload,
  // User,
  UserState,
  TProfileVideo,
} from "./userType";
import { TUser } from "@/types/types";

const initUser = {
  fullName: "",
  profilePicture: "",
  bio: "",
  age: 0,
  needsPasswordChanged: false,
  gender: undefined,
  address: {
    city: "",
    state: "",
    zipCode: "",
    country: "",
    mapLink: "",
  },
  phoneNumber: "",
  active: false,
  socialMedia: "",
  experience: "",
  uncomfortableIndustriesTopics: [],
  comfortableTopics: [],
  brandsDontWantToWorkWith: "",
  hoursPerWeek: "",
  availableInWeekends: false,
  salary: "",
  payPerVideo: "",
  wardrobeStyles: [],
  backGroundStyles: [],
  language: "",
  hasRelativesInVideo: false,
  props: [],
  greenScreen: undefined,
  audioEquipments: "",
  // cameraInfo: "",
  // lightingInfo: "",

  // noiselessRoomAndMicrophoneSpecs: "",
  // cameraOrSmartphoneSpecs: "",
  // lightingSpecs: "",
  // additionalInfo: "",

  noiselessRoomAndMicrophoneSpecs: {
    hasAudioEquipment: null,
    details: "",
  },
  cameraOrSmartphoneSpecs: {
    hasCamera: null,
    details: "",
  },
  lightingSpecs: {
    hasLighting: null,
    details: "",
  },
  additionalInfo: {
    hasAdditionalExperience: null,
    details: "",
  },
  propsAvailable: "",

  videoThumbnail: "",
  videos: [],
  hasTripod: false,
  hasArtificialLight: false,
  availableBackgrounds: [],
  videoLinks: [],
  bodyType: undefined,
  skinTone: undefined,
  user_id: "",
  email: "",
  type: undefined,
  actorTag: undefined,
  coreSetup: [],
  canBringToVideo: "",
  whoCanAppear: [],
  avoidTopics: [],
  portfolioVideos: [],
  comfortableWith: {},
  profileLinks: [],
  languagesWithFluency: [],
};

const initialState: UserState = {
  user: initUser,
  loading: false,
  error: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    resetUserChanges: (state, action: PayloadAction<TUser | null>) => {
      state.user = action.payload || initialState.user;
      state.error = initialState.error;
      state.loading = initialState.loading;
    },

    setUser: (state, action: PayloadAction<TUser>) => {
      state.user = action.payload;
      state.error = null;
    },
    updateUser: (state, action: PayloadAction<UpdateUserPayload>) => {
      const { field, value } = action.payload;
      (state.user[field] as any) = value;
    },
    updateAddressField: (
      state,
      action: PayloadAction<UpdateAddressPayload>,
    ) => {
      if (state.user?.address) {
        const { field, value } = action.payload;
        state.user.address[field] = value;
      }
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearUser: (state) => {
      state.user = initUser;
      state.error = null;
    },
    updateVideos: (state, action: PayloadAction<TProfileVideo[]>) => {
      if (state.user) {
        state.user.videos = action.payload;
      }
    },
    toggleVideoStatus: (state, action: PayloadAction<number>) => {
      if (state.user?.videos) {
        const videos = [...(state.user.videos || [])];
        if (videos[action.payload]) {
          videos[action.payload] = {
            ...videos[action.payload],
            isActive: !videos[action.payload].isActive,
          };
          state.user.videos = videos;
        }
      }
    },
    // updateEquipment: (
    //   state,
    //   action: PayloadAction<{
    //     field: "greenScreen" | "hasTripod" | "hasArtificialLight";
    //     value: boolean;
    //   }>
    // ) => {
    //   if (state.user) {
    //     const { field, value } = action.payload;
    //     (state.user[field] as boolean) = value;
    //   }
    // },
  },
});

export const {
  setUser,
  updateUser,
  updateAddressField,
  setLoading,
  setError,
  clearUser,
  updateVideos,
  toggleVideoStatus,
  // updateEquipment,
  resetUserChanges,
} = userSlice.actions;

export default userSlice.reducer;
